module.exports = {"520329001":"子营街道","520329102":"龙溪镇","520329103":"构皮滩镇","520329104":"大乌江镇","520329105":"敖溪镇","520329106":"龙家镇","520329107":"松烟镇","520329108":"关兴镇","520329109":"白泥镇","520329200":"花山苗族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/520329.json
// module id = 2286
// module chunks = 0